import React from "react";
import { useDispatch } from "react-redux";
import { KCheckbox, KDialog, KList } from "@kyburz/kdesign-system";
import { setAlert } from "../../../../redux/actions/actions";
import { cancelFsm, resetFsm } from "../../../../apiCalls/config/fsm";
import { FsmType } from "../types";

interface Props {
  fsmModalOpen: boolean;
  selectedImeis: string[];
  toggleFsmPopup: () => void;
  loading: boolean;
  handleFsmForce: (e: any) => void;
  fsmSuccess: () => void;
  startLoading: () => void;
  fsmType: FsmType;
  force: boolean;
}

const FsmPopup = ({
  fsmModalOpen,
  selectedImeis,
  toggleFsmPopup,
  loading,
  handleFsmForce,
  fsmSuccess,
  startLoading,
  fsmType,
  force,
}: Props) => {
  const dispatch = useDispatch();
  const handleFsm = () => {
    startLoading();
    const req = (fsmType === FsmType.reset)
      ? resetFsm(selectedImeis, force)
      : cancelFsm(selectedImeis);
    req.then((res) => {
      if (res) {
        const results = {};
        let all_ok = true;
        // eslint-disable-next-line guard-for-in,no-restricted-syntax
        for (const [imei, val] of Object.entries(res.data)) {
          const msg = `${val}`;
          if (msg !== "ok") {
            all_ok = false;
          }
          if (results[msg] === undefined) {
            results[msg] = [];
          }
          results[msg].push(imei);
        }
        const alert = (fsmType === FsmType.reset)
          ? `Fsm Reset Successful: ${JSON.stringify(results)}`
          : `Fsm Cancel Successful: ${JSON.stringify(results)}`;
        const sev = all_ok ? "success" : "warning";
        dispatch(setAlert(alert, sev));
        fsmSuccess();
      } else {
        dispatch(setAlert("Error Starting Fsm", "error"));
        fsmSuccess();
      }
    });
  };
  const forceCheckbox = (
    <KCheckbox
        handleChange={handleFsmForce}
        name="Force"
        label="Force"
        checked={force}
      />
  );

  return (
    <KDialog
      size="xs"
      title={`Fsm ${fsmType}`}
      open={fsmModalOpen}
      primaryCTAonClick={handleFsm}
      primaryCTAColor="primary"
      primaryCTAText={`${fsmType} ${selectedImeis.length} devices`}
      secondaryCTAonClick={toggleFsmPopup}
      secondaryCTAText="Cancel"
      hasOverflow
      disabled={loading}
    >
      {fsmType === FsmType.reset ? forceCheckbox : ""}
      <KList
        elements={
          selectedImeis[0] === "all"
            ? [
                "Not possible to select all imeis for now. Please filter by customer or select imeis manually",
              ]
            : selectedImeis
        }
        selectable={false}
        width="auto"
      />
    </KDialog>
  );
};

export default FsmPopup;
